// Dependency-free "Export to Excel" helper.
// Produces a UTF-8 CSV (with BOM so Excel renders ₹ and other characters correctly).
// CSV opens natively in Excel / Google Sheets with no extra libraries.

export function csvCell(value) {
  if (value === null || value === undefined) return '';
  let s = String(value);
  if (/[",\r\n]/.test(s)) {
    s = '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

// Pure: build a CSV string (with UTF-8 BOM) from headers + row matrix.
export function toCSV(headers, rows) {
  const lines = [headers.map(csvCell).join(',')];
  (rows || []).forEach(r => lines.push(r.map(csvCell).join(',')));
  return '﻿' + lines.join('\r\n');
}

// Pure: turn DataTable-style column defs + data into { headers, rows }.
// Each column may provide `exportValue(row)` for a custom plain value;
// otherwise the raw `row[col.key]` is used. Columns with `exportable: false`
// or the synthetic `__actions` column are skipped.
export function columnsToMatrix(columns, data) {
  const cols = (columns || []).filter(c => c && c.exportable !== false && c.key !== '__actions');
  const headers = cols.map(c => c.label ?? c.key);
  const rows = (data || []).map(row =>
    cols.map(c => {
      if (typeof c.exportValue === 'function') return c.exportValue(row);
      const v = row[c.key];
      return v === null || v === undefined ? '' : v;
    })
  );
  return { headers, rows };
}

export function downloadCSV(filename, headers, rows) {
  const csv = toCSV(headers, rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const safe = String(filename || 'export').replace(/[\\/:*?"<>|]+/g, '-');
  const name = `${safe}.csv`;

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

// Build headers/rows from DataTable-style column defs and trigger the download.
export function exportColumns(filename, columns, data) {
  const { headers, rows } = columnsToMatrix(columns, data);
  downloadCSV(filename, headers, rows);
}
